export class RechnungGeneration {
    von: Date;
    bis: Date;
    kunde_id: number;
    unternehmensgruppe_id: number;
    abgabebelege: number;
    befunde: number;
}
